import React from "react";
import { Route } from "react-router-dom";

import { PG, PGAccess, PGManage,PGView } from "../pages/ERP/pg";
import { FG, FGAccess, FGManage } from "../pages/ERP/fg";
import { WI, WIAccess, WIManage } from "../pages/ERP/wi";
import { Runcode, RuncodeAccess, RuncodeManage } from "../pages/ERP/runcode";

import {
  Customer,
  CustomerAccess,
  CustomerManage,
} from "../pages/ERP/customer";
import {
  Supplier,
  SupplierAccess,
  SupplierManage,
} from "../pages/ERP/supplier";
import {
  Packaging,
  PackagingAccess,
  PackagingManage,
} from "../pages/ERP/packaging";
import { Packing, PackingAccess, PackingManage } from "../pages/ERP/packing";

import {
  RawMaterial,
  RawMaterialAccess,
  RawMaterialManage,
} from "../pages/ERP/raw-material";
import {
  IndirectMaterial,
  IndirectMaterialAccess,
  IndirectMaterialManage,
} from "../pages/ERP/indirect-material";
import {
  Ingredients,
  IngredientsAccess,
  IngredientsManage,
} from "../pages/ERP/ingredients";
import { Bom, BomAccess, BomManage } from "../pages/ERP/bom";
import {
  MasterProcess,
  MasterProcessAccess,
  MasterProcessManage,
  MasterProcessView,
} from "../pages/ERP/master-process";

export const ERPDataRouter = (
  <>
    <Route path="/ERP/bom/" exact element={<Bom />}>
      <Route index element={<BomAccess />} />
      <Route path="manage/:action" element={<BomManage />} />
    </Route>

    <Route path="/ERP/master-process/" exact element={<MasterProcess />}>
      <Route index element={<MasterProcessAccess />} />
      <Route path="manage/:action" element={<MasterProcessManage />} />
      <Route path="view" element={<MasterProcessView />} />
    </Route>

    <Route path="/ERP/raw-material/" exact element={<RawMaterial />}>
      <Route index element={<RawMaterialAccess />} />
      <Route path="manage/:action" element={<RawMaterialManage />} />
    </Route>

    <Route path="/ERP/indirect-material/" exact element={<IndirectMaterial />}>
      <Route index element={<IndirectMaterialAccess />} />
      <Route path="manage/:action" element={<IndirectMaterialManage />} />
    </Route>

    <Route path="/ERP/ingredients/" exact element={<Ingredients />}>
      <Route index element={<IngredientsAccess />} />
      <Route path="manage/:action" element={<IngredientsManage />} />
    </Route>

    <Route path="/ERP/packing-goods/" exact element={<PG />}>
      <Route index element={<PGAccess />} />
      <Route path="manage/:action" element={<PGManage />} />
      <Route path="view" element={<PGView />} />
    </Route>

    <Route path="/ERP/finished-goods/" exact element={<FG />}>
      <Route index element={<FGAccess />} />
      <Route path="manage/:action" element={<FGManage />} />
    </Route>

    <Route path="/ERP/wi/" exact element={<WI />}>
      <Route index element={<WIAccess />} />
      <Route path="manage/:action" element={<WIManage />} />
    </Route>

    <Route path="/ERP/packaging/" exact element={<Packaging />}>
      <Route index element={<PackagingAccess />} />
      <Route path="manage/:action" element={<PackagingManage />} />
    </Route>

    <Route path="/ERP/packing-master/" exact element={<Packing />}>
      <Route index element={<PackingAccess />} />
      <Route path="manage/:action" element={<PackingManage />} />
    </Route>

    <Route path="/ERP/runcode/" exact element={<Runcode />}>
      <Route index element={<RuncodeAccess />} />
      <Route path="manage/:action" element={<RuncodeManage />} />
    </Route>

    <Route path="/ERP/customer/" exact element={<Customer />}>
      <Route index element={<CustomerAccess />} />
      <Route path="manage/:action" element={<CustomerManage />} />
    </Route>

    <Route path="/ERP/supplier/" exact element={<Supplier />}>
      <Route index element={<SupplierAccess />} />
      <Route path="manage/:action" element={<SupplierManage />} />
    </Route>
  </>
);
